let env = {};

env.baseURL = 'https://api.auditee.innovareti.com.br/api/v1/';
env.normalURL = 'https://api.auditee.innovareti.com.br/';

export default env
